document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('menu-open', isOpen);
    });
  }

  document.querySelectorAll('[data-submenu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.nav-item--has-children');
      const isOpen = item?.classList.toggle('submenu-open');
      button.setAttribute('aria-expanded', String(Boolean(isOpen)));
    });
  });

  document.querySelectorAll('[data-cookie-preferences]').forEach((button) => {
    button.addEventListener('click', () => {
      if (window.Shopify?.customerPrivacy?.showPreferences) {
        window.Shopify.customerPrivacy.showPreferences();
      } else if (window.Shopify?.customerPrivacy?.showConsentBanner) {
        window.Shopify.customerPrivacy.showConsentBanner();
      }
    });
  });

  document.querySelectorAll('[data-assessment]').forEach((shell) => {
    const form = shell.querySelector('.assessment-contact-form');
    if (!form || shell.querySelector('.assessment-success')) return;
    const steps = [...form.querySelectorAll('.assessment-step')];
    const bar = shell.querySelector('.assessment-progress span');
    const label = shell.querySelector('[data-step-label]');
    const summary = form.querySelector('[data-assessment-summary]');
    let index = 0;

    const render = () => {
      steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
      if (bar) bar.style.width = `${((index + 1) / steps.length) * 100}%`;
      if (label) label.textContent = `Step ${index + 1} of ${steps.length}`;
      steps[index]?.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true });
      shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const validate = (active) => {
      if (active.querySelector('[data-require-checkbox]') && !active.querySelector('input[type="checkbox"]:checked')) return false;
      return [...active.querySelectorAll('input[required]')].every((input) => {
        if (input.type === 'radio') return Boolean(active.querySelector(`input[name="${input.name}"]:checked`));
        if (input.type === 'checkbox') return input.checked;
        return input.checkValidity();
      });
    };

    const makeSummary = () => {
      const value = (name) => form.querySelector(`[name="${name}"]:checked`)?.value || '';
      const values = (name) => [...form.querySelectorAll(`[name="${name}"]:checked`)].map(i => i.value).join(', ');
      return [
        'New TRT assessment submission',
        `State: ${value('assessment_state')}`,
        `Age range: ${value('assessment_age')}`,
        `Symptoms: ${values('assessment_symptom')}`,
        `Duration: ${value('assessment_duration')}`,
        `Previously tested: ${value('assessment_tested')}`,
        `Previous TRT use: ${value('assessment_prior_trt')}`
      ].join('\n');
    };

    form.addEventListener('click', (event) => {
      const next = event.target.closest('[data-next]');
      const previous = event.target.closest('[data-prev]');
      if (next) {
        const active = steps[index];
        const error = active.querySelector('.assessment-error');
        if (!validate(active)) { if (error) error.hidden = false; return; }
        if (error) error.hidden = true;
        if (index < steps.length - 1) index += 1;
        render();
      }
      if (previous && index > 0) { index -= 1; render(); }
    });

    form.addEventListener('submit', (event) => {
      const active = steps[index];
      const error = active.querySelector('.assessment-error');
      if (!validate(active)) { event.preventDefault(); if (error) error.hidden = false; return; }
      if (summary) summary.value = makeSummary();
    });

    render();
  });

});
